import React from 'react';
import { Box, Typography, Container, Grid, Avatar } from '@mui/material';
import { ImgBox } from 'views/rebranded-module/common/components';
import useAdabtiveMultiSizeImage from 'views/common/hooks/useAdabtiveMultiSizeImage';
import StyledBox from 'views/rebranded-module/OffRoadToursLandingViewV2/components/TestimonialsSection/TestimonialsSection.styles';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import { RiDoubleQuotesL } from 'react-icons/ri';
import Typography500 from 'views/common/components/UI/Typography500';

const TestimonialsSection = () => {
  const content = useContent('OffRoadLandingPage');
  const getSizedImage = useAdabtiveMultiSizeImage();
  return (
    <StyledBox>
      <Box className="TSBackground">
        <ImgBox
          image={{
            src: getSizedImage(content.testimonialsBackground),
            alt: content.testimonialsBackground.alt,
          }}
          width="100%"
          height="100%"
          unoptimized
        />
      </Box>
      <Box className="TSGradient" />
      <Container maxWidth="xl" className="TSContent">
        <Box className="RFASContent">
          <Typography variant="overline2" component="h3" color="primary" mb={2}>
            {content.testimonialsTitle}
          </Typography>
          <Typography variant="h3" component="p" mb={6}>
            {content.testimonialsDescription}
          </Typography>
          <Grid container spacing={2}>
            {content.testimonials.map((testimonial) => (
              <Grid item lg={4} md={12} sm={12} key={testimonial.id}>
                <Box className="TSBox">
                  <Typography variant="h7" component="p" mb={2}>
                    {testimonial.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    component="p"
                    className="TSUserComment"
                    color="text.secondary">
                    {testimonial.comment}
                  </Typography>
                  <Box className="TSFooter" mt={2}>
                    <Box className="TSUserInfo">
                      <Avatar
                        className="TSAvatar"
                        alt={testimonial.name}
                        src={testimonial.image || undefined}>
                        {!testimonial.image &&
                          testimonial.name?.charAt(0).toUpperCase()}
                      </Avatar>
                      <Typography500
                        variant="body1"
                        component="span"
                        className="TSUserName"
                       >
                        {testimonial.name}
                      </Typography500>
                    </Box>
                    <RiDoubleQuotesL className="TSIcon" />
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </StyledBox>
  );
};

export { TestimonialsSection };
